import React from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {gtmRotatingPhoneNumbersCall} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    hotlineNumber: string;
}

export const ApplicationHotlinePhoneNumber = (props: IProps) => {
    return (
        <>
            <Text align="center" className={css({my: 2})} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                lub zadzwoń
            </Text>
            <div className={hotlineWrapper}>
                <div className={hotlineStyle}>
                    <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                    <Link
                        className={linkUnstyled}
                        href={`tel:+${props.hotlineNumber}`}
                        onClick={() => {
                            gtmRotatingPhoneNumbersCall();
                        }}
                    >
                        <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                            {phoneNumberFormat(props.hotlineNumber)}
                        </Text>
                    </Link>
                </div>
            </div>
        </>
    );
};

const hotlineWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const hotlineStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2
});

const linkUnstyled = css({
    ml: 2,
    "&:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});
import React from "react";
import {css} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {gtmRotatingPhoneNumbersCall} from "../../tracking/google_tag_manager/gtm_rotating_phone_numbers";

interface IProps {
    hotlineNumber: string;
}

export const ApplicationHotlinePhoneNumber = (props: IProps) => {
    return (
        <>
            <Text align="center" className={css({my: 2})} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                lub zadzwoń
            </Text>
            <div className={hotlineWrapper}>
                <div className={hotlineStyle}>
                    <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                    <Link
                        className={linkUnstyled}
                        href={`tel:+${props.hotlineNumber}`}
                        onClick={() => {
                            gtmRotatingPhoneNumbersCall();
                        }}
                    >
                        <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                            {phoneNumberFormat(props.hotlineNumber)}
                        </Text>
                    </Link>
                </div>
            </div>
        </>
    );
};

const hotlineWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
});

const hotlineStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2
});

const linkUnstyled = css({
    ml: 2,
    "&:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});
